import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-discussion',
  templateUrl: './card-discussion.component.html',
  styleUrls: ['./card-discussion.component.sass']
})
export class CardDiscussionComponent implements OnInit {
  @Input() data
  @Input() index

  constructor() { }

  ngOnInit(): void {
  }

}
